import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { Toaster } from './components/ui/toaster';
import Home from './components/Home';
import Services from './components/Services';
import Booking from './components/Booking';
import Solutions from './components/Solutions';
import Contact from './components/Contact';
import Login from './components/Login';
import Dashboard from './components/dashboard/Dashboard';

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/book" element={<Booking />} />
            <Route path="/property-managers" element={<Solutions slug="property-managers" />} />
            <Route path="/contractors" element={<Solutions slug="contractors" />} />
            <Route path="/franchise" element={<Solutions slug="franchise" />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AppProvider>
    </div>
  );
}

export default App;
